import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, mergeMap, switchMap, take, tap} from 'rxjs/operators';
import {from, of} from 'rxjs';
import {AuthenticationService} from '../../core/services/auth/authentication.service';
import {
  login,
  loginFailure,
  loginFailureFirebase,
  loginFirebase,
  loginSuccess,
  loginSuccessFirebase,
  logout
} from './auth.action';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {stopLoading} from '../layout/layout.action';
import {Auth, signInWithEmailAndPassword} from '@angular/fire/auth';
import {ProviderUser} from '../../core/models/auth';
import {TranslocoService} from '@jsverse/transloco';
import {SharedUtils} from "../../shared/services/utils/shared-utils.service";

@Injectable(
  { providedIn: 'root' }
)
export class AuthEffects {

  private auth = inject(Auth);
  constructor(private actions$: Actions, private authService: AuthenticationService, public translateService: TranslocoService,
    private router: Router, private store: Store) { }

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),

      mergeMap((action) =>
        this.authService.login(action.email, action.password).pipe(
          take(1),
          map((response) => {
            this.store.dispatch(stopLoading());
            SharedUtils.instance().messageUtils().push('info', 'titleInfo', 'loginok' );
            //this.messageService.add({ severity: 'info', summary: this.translateService.translate('titleInfo'), detail:   this.translateService.translate('loginok') });


            this.router.navigate(['app/dashboard']);


            return loginSuccess({ authResponse: response });
          }),
          catchError((error) => {
            this.store.dispatch(stopLoading());
            SharedUtils.instance().messageUtils().push('contrast', 'titleInfo', 'errorLogin' );
            return of(loginFailure({ error: error.message }))

          })
        )
      )
    )
  );


  loginFire$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loginFirebase),
      switchMap(({ email, password }) =>
        from(signInWithEmailAndPassword(this.auth, email, password)).pipe(
          take(1),
          map((userCredential: any) => {
            const user = userCredential.user;
            this.store.dispatch(stopLoading());
            //SharedUtils.instance().messageUtils().push('info', 'titleInfo', 'loginok' );

            return loginSuccessFirebase({
              firebaseResponse: {
                user: {
                  email: user.email || '',
                  emailVerified: user.emailVerified,
                  providerData: user.providerData as ProviderUser[]
                },
                _tokenResponse: userCredential._tokenResponse
              }
            });


          }),
          tap(() => window.location.href = '/app/dashboard'),
          catchError((error) => {
            this.store.dispatch(stopLoading());
            SharedUtils.instance().messageUtils().push('contrast', 'titleInfo', 'errorLogin' );
            return of(loginFailureFirebase({ error: error.message }));
          })
        )
      )
    )
  );

  logout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logout),
        tap(() => {


          SharedUtils.instance().currentUser().active = false;
          console.log("SharedUtils.instance().currentUser().active", SharedUtils.instance().currentUser().active )

          localStorage.clear()
          sessionStorage.clear()

          window.location.href ='/auth';
        })
      ),
    { dispatch: false } // No necesitamos despachar una nueva acción desde este efecto, o si??
  );

  loginSuccessAction$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType( loginSuccess,loginSuccessFirebase),
        tap(() => {
          console.log("loginSuccess,loginSuccessFirebase")
          if(SharedUtils?.instance()?.currentUser()) {
            queueMicrotask(() => {
              SharedUtils.instance().currentUser().active = true;
              console.log("SharedUtils.instance().currentUser().active", SharedUtils.instance().currentUser().active)
            });
          }
        })
      ),
      { dispatch: false }
  );
}
